// TABS
jQuery('.tablinks').on('click', function (evt) {
  var i, tabcontent, tablinks;
  var tab = jQuery(this).attr('data-tab');
  tabcontent = document.getElementsByClassName('tabcontent');
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none';
  }
  tablinks = document.getElementsByClassName('tablinks');
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(' active', '');
  }
  document.getElementById(tab).style.display = 'block';
  evt.currentTarget.className += ' active';
});

// Modal
var modal = document.getElementById('myModal');
var btn = document.getElementById('open_modal');
var closeBtn = document.getElementsByClassName('close')[0];

// When the user clicks the button, open the modal
if (btn) {
  btn.onclick = function () {
    var videoEl = document.getElementById('heroVidModal');
    if (videoEl) {
      videoEl.play();
    }
    modal.style.display = 'block';
  };
}

// Stop video when click outside of modal
if (!jQuery('body').hasClass('watchlist-template')) {
  jQuery('body').click(() => {
    var videoEl = document.getElementById('heroVidModal');
    if (videoEl && !videoEl.paused) {
      videoEl.pause();
    }
  });
}

// close modal
if (closeBtn) {
  closeBtn.onclick = function () {
    modal.style.display = 'none';
    var videoEl = document.getElementById('heroVidModal');
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
    }
  };
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = 'none';
    var videoEl = document.getElementById('heroVidModal');
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
    }
  }
};

// Accordions
var acc = jQuery('.tr_accordion');
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener('click', function () {
    this.classList.toggle('active');
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      panel.style.border = 0;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.style.borderBottom = '1px solid #666';
    }
  });
}

// Open all accordions
jQuery('.control_all').on('click', function () {
  let text = jQuery('.control_all').text();
  jQuery('.control_all').text(
    text == 'Expand All +' ? 'Collapse All -' : 'Expand All +'
  );
  for (i = 0; i < acc.length; i++) {
    var panel = acc[i].nextElementSibling;
    if (text == 'Expand All +') {
      jQuery(acc[i]).addClass('active');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.style.borderBottom = '1px solid #666';
    } else {
      jQuery(acc[i]).removeClass('active');
      panel.style.maxHeight = null;
      panel.style.border = 0;
    }
  }
});
